import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import uniqueId from 'lodash.uniqueid';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import PegRewardCardList from './PegRewardCardList';
import { rewardsDuck } from '../../ducks/rewards';
import { connect } from 'react-redux';
import { getSessionStorageKey } from '../../util/sessionStorage';
import { getLoyaltyStorage } from '../../util';
import { LoyaltyAccountStatus } from '../../util/LoyaltyAccountStatus';
var rewardsOperations = rewardsDuck.operations;

var PegRewardListing = function PegRewardListing(props) {
  var _props$model = props.model,
      _props$model$levelIte = _props$model.levelItems,
      levelItems = _props$model$levelIte === void 0 ? [] : _props$model$levelIte,
      _props$model$header = _props$model.header,
      header = _props$model$header === void 0 ? {} : _props$model$header,
      _props$model$copy = _props$model.copy,
      copy = _props$model$copy === void 0 ? {} : _props$model$copy,
      _props$model$copyNotE = _props$model.copyNotEnough,
      copyNotEnough = _props$model$copyNotE === void 0 ? {} : _props$model$copyNotE;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      levelItemsAux = _useState2[0],
      setLevelItemsAux = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      userPegs = _useState4[0],
      setUserPegs = _useState4[1];

  var _useState5 = useState(copy),
      _useState6 = _slicedToArray(_useState5, 2),
      copyState = _useState6[0],
      setCopyState = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      pausedAccount = _useState8[0],
      setPausedAccount = _useState8[1];

  var id = uniqueId();
  var loyaltyStorage = getLoyaltyStorage();
  useEffect(function () {
    var _loyaltyStorage$accou;

    if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused) {
      setPausedAccount(true);
      return;
    }

    var rewardsStorage = getSessionStorageKey('rewards');

    if (rewardsStorage === null || rewardsStorage === void 0 ? void 0 : rewardsStorage.userPegs) {
      setUserPegs(parseInt(rewardsStorage === null || rewardsStorage === void 0 ? void 0 : rewardsStorage.userPegs));
    } // Storybook only


    if (props.storybookPegsBalance) {
      setUserPegs(parseInt(props.storybookPegsBalance));
    }

    setLevelItemsAux(levelItems.filter(function (level) {
      var _level$fields, _level$fields$pegRewa, _level$fields2, _level$fields2$reward;

      return !!(((_level$fields = level.fields) === null || _level$fields === void 0 ? void 0 : (_level$fields$pegRewa = _level$fields.pegRewardCard) === null || _level$fields$pegRewa === void 0 ? void 0 : _level$fields$pegRewa.length) && ((_level$fields2 = level.fields) === null || _level$fields2 === void 0 ? void 0 : (_level$fields2$reward = _level$fields2.rewardAmount) === null || _level$fields2$reward === void 0 ? void 0 : _level$fields2$reward.value) > 0);
    }).sort(function (a, b) {
      var _a$fields, _a$fields$rewardAmoun, _b$fields, _b$fields$rewardAmoun;

      return parseInt(((_a$fields = a.fields) === null || _a$fields === void 0 ? void 0 : (_a$fields$rewardAmoun = _a$fields.rewardAmount) === null || _a$fields$rewardAmoun === void 0 ? void 0 : _a$fields$rewardAmoun.value) || 1000) - parseInt(((_b$fields = b.fields) === null || _b$fields === void 0 ? void 0 : (_b$fields$rewardAmoun = _b$fields.rewardAmount) === null || _b$fields$rewardAmoun === void 0 ? void 0 : _b$fields$rewardAmoun.value) || 1000);
    }));
    window.addEventListener("customEventSetLoyaltyAccountData", function (e) {
      var _e$detail, _e$detail$account;

      var Balance = (e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : (_e$detail$account = _e$detail.account) === null || _e$detail$account === void 0 ? void 0 : _e$detail$account.Balance) || null;

      if (Balance) {
        setUserPegs(parseInt(Balance));
      }
    });
    return function () {
      window.removeEventListener("customEventSetLoyaltyAccountData", function () {});
    };
  }, []);
  useEffect(function () {
    var _levelItemsAux$, _levelItemsAux$$field, _levelItemsAux$$field2;

    if (parseInt(userPegs) < parseInt(levelItemsAux === null || levelItemsAux === void 0 ? void 0 : (_levelItemsAux$ = levelItemsAux[0]) === null || _levelItemsAux$ === void 0 ? void 0 : (_levelItemsAux$$field = _levelItemsAux$.fields) === null || _levelItemsAux$$field === void 0 ? void 0 : (_levelItemsAux$$field2 = _levelItemsAux$$field.rewardAmount) === null || _levelItemsAux$$field2 === void 0 ? void 0 : _levelItemsAux$$field2.value)) {
      setCopyState(copyNotEnough);
    }
  }, [userPegs, levelItemsAux]);

  if (pausedAccount) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: 'container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'row'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'col-lg-12'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-listing'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-listing__header-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: header,
    className: 'cb-peg-reward-listing__header'
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: copyState,
    className: 'cb-peg-reward-listing__copy'
  })), levelItemsAux === null || levelItemsAux === void 0 ? void 0 : levelItemsAux.map(function (level, index) {
    return /*#__PURE__*/React.createElement(PegRewardCardList, {
      key: "level-list-".concat(id, "-").concat(index),
      model: level.fields,
      userPegs: userPegs
    });
  })))));
};

export default PegRewardListing;